import { useNavigate } from 'react-router-dom'

/** Гаджет: Документы и ТО: сроки. */

export function RemindersWidget({ data }) {
  const navigate = useNavigate()

  if (!data.items.length) {
    return <p className="widget-empty">Ближайших сроков нет</p>
  }

  return (
    <div className="reminders-widget">
      <div className="reminders-widget__summary">
        {data.counts.danger > 0 && (
          <span className="chip chip--danger">{data.counts.danger} срочных</span>
        )}
        {data.counts.warning > 0 && (
          <span className="chip chip--warning">{data.counts.warning} на подходе</span>
        )}
        <button
          type="button"
          className="btn btn--ghost btn--sm"
          onClick={() => navigate('/admin/reminders')}
        >
          Все сроки
        </button>
      </div>

      <ul className="widget-list">
        {data.items.map((r, i) => (
          <li key={`${r.car_id}-${r.label}-${i}`}>
            <button
              type="button"
              className={`reminders-widget__row reminders-widget__row--${r.level}`}
              onClick={() => navigate(`/admin/cars/${r.car_id}`)}
            >
              <span className="reminders-widget__label">{r.label}</span>
              <span className="reminders-widget__car">
                {r.car}
                {r.plate ? <span className="plate">{r.plate}</span> : null}
              </span>
              <span className="reminders-widget__days">
                {r.days_left < 0
                  ? `просрочено ${Math.abs(r.days_left)} дн.`
                  : r.days_left === 0
                    ? 'сегодня'
                    : `через ${r.days_left} дн.`}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
